export default __webpack_public_path__ + "static/media/home-banner.91677875.png";